module.exports = __webpack_public_path__ + "images/FUSA_icons/071-worldwide.01b383736a8c1277a0b6f704d58a934d.svg";